import React, { Fragment } from "react";
import { Dialog, Slide } from "@mui/material";
import { compose } from "recompose";
import styles from "./styles";
import { withSnackbar } from "notistack";
import { withStyles } from "@mui/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BuyerPermissionModal = (props) => {
  const { onConfirm, onCancel, propertyAddress } = props;

  return (
    <Fragment>
      <Dialog
        open={true}
        aria-labelledby="buyer-permission-dialog-title"
        aria-describedby="buyer-permission-dialog-description"
        maxWidth="sm"
        fullWidth={true}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            minHeight: "220px",
          },
        }}
      >
        <div className="buyer-permission-modal-container">
          <div className="buyer-permission-modal-text">
            <p id="buyer-permission-dialog-title">
              I have permission to show this property
            </p>
            {propertyAddress && (
              <p className="buyer-permission-modal-address">{propertyAddress}</p>
            )}
          </div>
          <div className="buyer-permission-modal-button-container">
            <button
              type="button"
              className="property-highlights-submit-button"
              onClick={onCancel}
            >
              <p>No</p>
            </button>
            <button
              type="button"
              className="property-highlights-submit-button"
              onClick={onConfirm}
            >
              <p>Yes</p>
            </button>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};

export default compose(withSnackbar, withStyles(styles))(BuyerPermissionModal);
